module.exports = __webpack_public_path__ + "img/scan.04ca3b80.png";